import React, { useMemo, useState } from 'react';
import cx from 'classnames';
import styles from './Card.module.scss';
import { Icon } from '../Icon';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../common/components/Spinner';

const CardThumbnail = ({
  listMode,
  isHoverCard,
  className,
  src,
  alt,
  isMobileView,
  processing,
  isDraft,
  showDraftStatus = true,
  isShowApprovalStatus,
  approvalStatus,
  fadeInComponent,
  childClassName,
  imageClassName,
  fallbackSvg,
  ...rest
}) => {
  const [loadError, setLoadError] = useState(false);
  const { t } = useTranslation();

  const image = useMemo(() => {
    if (!processing) {
      if (isDraft) {
        return <div className={styles.draftThumbnail} />;
      } else {
        if (src) {
          if (loadError) {
            return <Icon className={styles.mediaMissingIcon} src={fallbackSvg ? fallbackSvg : "mediaMissing"} />;
          }
          return <img className={cx(styles.image)} src={src} alt={alt} onError={() => setLoadError(true)} />;
        } else if (fallbackSvg) {
          return <Icon className={styles.mediaMissingIcon} src={fallbackSvg} />;
        }
      }
    }
    return <Spinner width={'30px'} height={'30px'} size={'3px'} className={styles.spinner} />;
  }, [isDraft, loadError, processing, setLoadError, src]);

  return (
    <div className={className} {...rest}>
      <div className={cx(listMode ? styles.thumbnailList : styles.thumbnail, childClassName)}>
        {image}
        <div className={cx(styles.overlay, { [styles.hover]: isHoverCard })}></div>
        {(!isDraft && isHoverCard && fadeInComponent) || isMobileView ? fadeInComponent : null}
        {showDraftStatus && isDraft ? (
          <div className={styles.draftStatus}>
            <span>{t('dashboard.card_col.draft_status')}</span>
          </div>
        ) : (
          isShowApprovalStatus && (
            <div className={styles.videoStatus}>
              <span>{approvalStatus}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default CardThumbnail;
